module.exports = __webpack_public_path__ + "media/620.66bb3bb9.mp3";